"use client";

import { authApi } from "#/api/authApi";
import { useAuth } from "#/hook/useAuth";
import { useMsal } from "@azure/msal-react";
import { Button } from "@mantine/core";
import { useMutation } from "@tanstack/react-query";
import { logger } from "#/utils/logger";
import { useTranslation } from "react-i18next";

export default function EntraSSOLoginButton() {
  const { t } = useTranslation();
  const { processLogin } = useAuth();
  const { instance } = useMsal();

  const login = useMutation({
    mutationFn: async (token: string) => {
      return await authApi.loginWithMicrosoft(token);
    },
    onSuccess: (res) => {
      void processLogin(res.data);
    },
    onError: (error) => {
      logger.error("EntraSSOLoginButton login error:", error);
    },
  });

  const handleEntraSSO = async () => {
    try {
      const result = await instance.loginPopup({
        scopes: ["openid", "profile", "email", "User.Read"],
        state: `full-url=${encodeURIComponent(window.location.href)}`,
      });
      if (result.idToken) {
        login.mutate(result.idToken);
      }
    } catch (err) {
      logger.error("MSAL popup error:", err);
    }
  };

  return (
    <Button
      fullWidth
      size="md"
      color="black"
      autoContrast
      leftSection={
        <img alt="ms" src={"/icons/ic_ms.png"} height={20} width={20} />
      }
      onClick={handleEntraSSO}
      loading={login.isPending}
    >
      {t("auth.login.signInWithMicrosoft")}
    </Button>
  );
}
